import { createSelector } from '@ngrx/store';
import * as fromLocationHistory from '../reducers/location-history.reducer';
import { selectLocationHistoryState } from '../reducers';

export const getLocationHistoryList = createSelector(
  selectLocationHistoryState,
  fromLocationHistory.getLocationHistoryList,
);
export const getLocationHistoryStats = createSelector(
  selectLocationHistoryState,
  fromLocationHistory.getLocationHistoryStats,
);
export const getLocationHistoryLoading = createSelector(
  selectLocationHistoryState,
  fromLocationHistory.getLocationHistoryLoading,
);
